
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[id]",
      function () {
        return require("private-next-pages/services/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[id]"])
      });
    }
  